if (!customElements.get('cro-school-filter')) {
class CroSchoolFilter extends HTMLElement {
connectedCallback() {
 if(this.bound)return; this.bound=true;
 this.vendors=JSON.parse(this.querySelector('[data-vendors]').textContent).sort((a,b)=>a.localeCompare(b));
 this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);this.aliases=[];this.cache=new Map();
 this.input=this.querySelector('input');this.options=this.querySelector('.cro-school-filter__options');this.status=this.querySelector('[data-status]');
 this.current=new URL(location.href).searchParams.get('cro_school')||'';
 this.renderOptions();this.input.addEventListener('input',()=>this.renderOptions());
 this.querySelector('details').addEventListener('toggle',()=>{if(this.querySelector('details').open){this.loadAliases();this.input.focus();}});
 if(this.current)this.apply(this.current,false);
 const container=document.getElementById('ProductGridContainer');
 if(container){this.observer=new MutationObserver(()=>{const selected=new URL(location.href).searchParams.get('cro_school');if(selected)this.apply(selected,false);});this.observer.observe(container,{childList:true});}
}
disconnectedCallback(){this.observer?.disconnect();}
norm(s){return String(s||'').toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]/g,'');}
async loadAliases(){
 if(this.aliasPromise)return this.aliasPromise;
 const root=window.Shopify?.routes?.root||'/';
 this.aliasPromise=fetch(root+'pages/shop-by-schools').then(r=>{if(!r.ok)throw Error();return r.text();}).then(html=>{
 const doc=new DOMParser().parseFromString(html,'text/html');
 this.aliases=Array.from(doc.querySelectorAll('.collection-list__item')).map(item=>({title:item.dataset.school||item.dataset.schoolTitle||item.querySelector('.simple-collection-title a')?.textContent||'',terms:[item.dataset.searchTerms,item.dataset.acronym,item.dataset.nicknames,item.textContent].filter(Boolean).join(' ')}));
 this.renderOptions();
 }).catch(()=>{});return this.aliasPromise;
}
match(v,q){
 if(this.norm(v).includes(q))return true;
 return this.aliases.some(a=>{const n=this.norm(a.title);const school=this.norm(v);return (n===school||n.includes(school)||school.includes(n))&&n.length>3&&(q.length<=3 ? a.terms.toLowerCase().split(/[^a-z0-9]+/).includes(q) : this.norm(a.terms).includes(q));});
}
renderOptions(){
 const q=this.norm(this.input.value);this.options.replaceChildren();
 const choices=['',...this.vendors.filter(v=>!q||this.match(v,q))];
 choices.forEach(v=>{const b=document.createElement('button');b.type='button';b.textContent=v||this.labels.all;b.setAttribute('aria-pressed',String(v===this.current));b.addEventListener('click',()=>this.apply(v,true));this.options.append(b);});
 this.querySelector('[data-empty]').hidden=choices.length>1;
}
async apply(v,push){
 const url=new URL(location.href);url.searchParams.delete('page');
 if(v)url.searchParams.set('cro_school',v);else url.searchParams.delete('cro_school');
 if(!v){location.assign(url.toString());return;}
 this.current=v;this.querySelector('[data-selected]').textContent='— '+v;this.querySelector('details').open=false;this.renderOptions();
 if(push)history.pushState({},'',url);
 this.token=(this.token||0)+1;const token=this.token;this.status.textContent=this.labels.loading;
 try{
 const key=url.pathname+'?'+Array.from(url.searchParams).filter(([k])=>!['cro_school','preview_theme_id'].includes(k)).map(([k,val])=>encodeURIComponent(k)+'='+encodeURIComponent(val)).join('&');
 let items=this.cache.get(key);
 if(!items){
 const container=document.getElementById('ProductGridContainer');let pages=Number(container.dataset.croPages)||1;
 const all=[];const base=new URL(url);base.searchParams.delete('cro_school');base.searchParams.set('section_id',this.dataset.section);
 for(let p=1;p<=pages;p++){
 base.searchParams.set('page',p);
 const response=await fetch(base.toString());if(!response.ok)throw Error('School results could not be loaded');
 const doc=new DOMParser().parseFromString(await response.text(),'text/html');
 if(p===1)pages=Number(doc.getElementById('ProductGridContainer')?.dataset.croPages)||pages;
 all.push(...Array.from(doc.querySelectorAll('#product-grid>li[data-school-vendor]')));
 }
 items=all;this.cache.set(key,items);
 }
 if(token!==this.token||!this.isConnected)return;
 const shown=items.filter(item=>item.dataset.schoolVendor===v);
 const grid=document.getElementById('product-grid');if(!grid)throw Error('Product grid unavailable');
 grid.replaceChildren(...shown.map(item=>item.cloneNode(true)));
 grid.querySelectorAll('.scroll-trigger').forEach(item=>item.classList.remove('scroll-trigger','animate--slide-in','animate--fade-in'));
 const container=document.getElementById('ProductGridContainer');container.querySelectorAll('.pagination-wrapper').forEach(el=>el.hidden=true);
 document.querySelectorAll('#ProductCount,#ProductCountDesktop').forEach(el=>el.textContent=shown.length+' products');
 this.status.textContent=shown.length+' products for '+v;
 const b=document.createElement('button');b.type='button';b.className='link underlined-link';b.textContent=this.labels.clear;b.addEventListener('click',()=>this.apply('',true));this.status.append(' · ',b);
 document.querySelectorAll('facet-filters-form form').forEach(form=>{let hidden=form.querySelector('input[name="cro_school"]');if(!hidden){hidden=document.createElement('input');hidden.type='hidden';hidden.name='cro_school';form.append(hidden);}hidden.value=v;});
 }catch(error){if(token===this.token)this.status.textContent='School results could not be loaded. Please try again.';}
}
}
customElements.define('cro-school-filter',CroSchoolFilter);
}